#ifdef USE_NUMBERS
    // Convert normal to world space for bumpNumbers
    vec3 normalW = inverseTransformDirection(normal, viewMatrix);

    vec3 bumpedW = bumpNumbers(normalW);

    // Convert bumped normal back to view space
    normal = transformDirection(bumpedW, viewMatrix);
#endif
